import { Button, Col, Form, Input, Modal, Radio, Row, InputNumber, Upload } from 'antd'
import FormModalWrapper from 'components/Form/FormModalWrapper'
import { useCallback, useEffect, useRef, useState } from 'react'
import { CloseOutlined, PlusOutlined, UploadOutlined } from '@ant-design/icons'
import styled from 'styled-components'
import { API_BASE_URL } from 'constants/index'

import axios from 'axios'
import fetchHelper, { getAuthToken } from 'helpers/FetchHelper'
import { toast } from 'react-toastify'
import { productService } from 'services'
import moment from 'moment-timezone'
import { NumericFormat } from 'react-number-format'

const ModalBody = styled.div`
  padding-right: 10px;

  > div {
    padding: 0;
    box-shadow: none;
  }
`

const ButtonGroups = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
`
const getBase64 = (file: any): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result as string)
    reader.onerror = (error) => reject(error)
  })

const ModalUpdateProduct = ({ open, onCancel, productId }) => {
  const [form] = Form.useForm()
  const auth = getAuthToken()

  const [imageProduct, setImageProduct] = useState<any>(null)
  const [price, setPrice] = useState<any>('')
  const [productPrice, setProductPrice] = useState<any>('')

  const [weight, setWeight] = useState<any>('')

  const [loading, setLoading] = useState<boolean>(true)
  const handleBeforeUpload = async (file: any) => {
    return false
  }
  const handleChangeUpload = async (file: any) => {
    if (file.fileList[0].originFileObj instanceof File) {
      const base64 = await getBase64(file.fileList[0].originFileObj)
      file.file.base64 = base64
    }
    setImageProduct(file);

  }
  const removeImage = () => {
    setImageProduct(null);
  }
  const handleCancel = () => {
    form.resetFields()
    setPrice('')
    setProductPrice('')
    setWeight('')
    removeImage();
    onCancel();
  }
  const getDetailProduct = useCallback(() => {
    if (productId != 0) {
      productService.getDetail(productId, (response) => {
        setLoading(false)
        form.setFieldsValue({
          title: response?.data?.product?.title,
          code: response?.data?.product?.code,
        })
        setPrice(response?.data?.product?.price)
        setProductPrice(response?.data?.product?.product_price)
        setWeight(response?.data?.product?.weight)
        setImageProduct({
          file: {
            id: response?.data?.product?.id,
            uid: response?.data?.product?.id,
            name: response?.data?.product?.title,
            status: 'done',
            url: response?.data?.product?.avatar,
            base64: response?.data?.product?.avatar,
          }
        })
      })
    }
  }, [productId, form, setPrice, setWeight])
  useEffect(() => {
    getDetailProduct()
  }, [productId, form])

  const handleSubmit = useCallback(() => {
    form.validateFields().then(async (values) => {
      setLoading(true)
      const formData = new FormData()

      formData.append('title', values?.title || '')
      formData.append('code', values?.code || '')
      formData.append('price', price || 0)
      formData.append('product_price', productPrice || 0)
      formData.append('weight', weight || 0)
      if (imageProduct?.fileList) {
        if (imageProduct?.fileList[0].originFileObj instanceof File) {
          formData.append('avatar', imageProduct?.fileList[0]?.originFileObj, `image_${moment().unix()}.png`)
        }

      }
      const response = await axios.post(`${API_BASE_URL}/customer/product/update/${productId}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${auth}`,
        },
      })

      if (response?.data?.error) {
        toast.error(response?.data?.message, { autoClose: false })
        setLoading(false)
      } else {
        setLoading(false)
        handleCancel()
      }
      fetchHelper.addDefaultHeader('Content-Type', 'application/json')

      return
    })
  }, [form, imageProduct, handleCancel, price, weight])

  return (
    <Modal
      title={<p style={{ fontSize: '20px', fontWeight: 700 }}>Chỉnh sửa sản phẩm</p>}
      open={open}
      footer={false}
      centered
      onCancel={() => {
        if (!loading) {
          handleCancel()
        }
      }}
      width={700}
      maskClosable={false}
    >
      <ModalBody>
        <FormModalWrapper>
          <Form form={form} labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
            <Row>
              <Col span={24}>
                <Form.Item
                  label='Tên sản phẩm'
                  name='title'
                  rules={[{ required: true, message: 'Vui lòng nhập tên sản phẩm ' }]}
                >
                  <Input placeholder='Nhập tên sản phẩm' />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item
                  label='Mã sản phẩm'
                  name='code'
                >
                  <Input placeholder='Nhập mã sản phẩm' />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item label='Tiền hàng'>
                  <div className='box-input-number'>

                    <NumericFormat
                      className='number-format'
                      allowLeadingZeros
                      thousandSeparator=','
                      value={price}
                      onValueChange={(e) => {
                        setPrice(e?.floatValue)
                      }}
                      isAllowed={(values: any) => {
                        const { floatValue } = values
                        if (floatValue) {
                          return floatValue <= 999999999999
                        }
                        return true
                      }}
                      placeholder='Nhập tiền hàng (VNĐ)'
                      defaultValue={price}
                    />
                    <span className="suffix">VNĐ</span>
                  </div>
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item label='Khai giá hàng hóa'>
                  <div className='box-input-number'>
                    <NumericFormat
                      className='number-format'
                      allowLeadingZeros
                      thousandSeparator=','
                      value={productPrice}
                      onValueChange={(e) => {
                        setProductPrice(e?.floatValue)
                      }}
                      isAllowed={(values: any) => {
                        const { floatValue } = values
                        if (floatValue) {
                          return floatValue <= 999999999999
                        }
                        return true
                      }}
                      placeholder='Khai giá hàng hóa (VNĐ)'
                      defaultValue={productPrice}
                    />
                    <span className="suffix">VNĐ</span>
                  </div>
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item label='Khối lượng sản phẩm:'>
                  <div className='box-input-number'>

                    <NumericFormat
                      className='number-format'
                      allowLeadingZeros
                      value={weight}
                      onValueChange={(e) => {
                        setWeight(e?.floatValue)
                      }}
                      isAllowed={(values: any) => {
                        const { floatValue } = values
                        if (floatValue) {
                          return floatValue <= 999999999999
                        }
                        return true
                      }}
                      placeholder='Nhập khối lượng sản phẩm (KG)'
                      defaultValue={weight}
                    />
                    <span className="suffix">KG</span>
                  </div>
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item label='Hình ảnh sản phẩm'>
                  {imageProduct == null && (
                    <Upload
                      beforeUpload={handleBeforeUpload}
                      onChange={handleChangeUpload}
                      listType='picture-card'
                      fileList={imageProduct}
                      accept='.jpg,.jpeg,.png'
                    >
                      <div><PlusOutlined /><div>Upload</div></div>
                    </Upload>
                  )}
                  {imageProduct != null && (

                    <div key={imageProduct?.file?.uid} className='item-upload-image'>
                      <CloseOutlined onClick={() => removeImage()} />
                      <img src={imageProduct?.file?.base64} alt='' style={{ width: '104px', height: '104px', objectFit: 'cover' }} />
                    </div>
                  )}
                </Form.Item>
              </Col>
              <Col span={24}>
                <ButtonGroups>
                  <Button type='primary' size='large' onClick={handleSubmit} loading={loading}>
                    Xác nhận
                  </Button>
                  <Button
                    size='large'
                    loading={loading}
                    onClick={() => {
                      if (!loading) {
                        handleCancel()
                      }
                    }}
                  >
                    Thoát
                  </Button>
                </ButtonGroups>
              </Col>
            </Row>
          </Form>
        </FormModalWrapper>
      </ModalBody>
    </Modal>
  )
}

export default ModalUpdateProduct
